import { createSlice } from '@reduxjs/toolkit';
import { HelpBubbleState } from './types';

const initialState: HelpBubbleState = {
  isRoleSelectionVisible: false,
  isAttendeeTicketsModalVisible: false,
};

export const helpBubbleSlice = createSlice({
  name: 'helpBubble',
  initialState,
  reducers: {
    openRoleSelection: (state) => {
      state.isRoleSelectionVisible = true;
    },
    closeRoleSelection: (state) => {
      state.isRoleSelectionVisible = false;
    },
    openAttendeeTicketsModal: (state) => {
      state.isAttendeeTicketsModalVisible = true;
    },
    closeAttendeeTicketsModal: (state) => {
      state.isAttendeeTicketsModalVisible = false;
    },
    resetHelpBubble: (state) => {
      state.isRoleSelectionVisible = false;
      state.isAttendeeTicketsModalVisible = false;
    },
  },
});

export const {
  openRoleSelection,
  closeRoleSelection,
  openAttendeeTicketsModal,
  closeAttendeeTicketsModal,
  resetHelpBubble,
} = helpBubbleSlice.actions;

export default helpBubbleSlice.reducer;
